export default __webpack_public_path__ + "static/seal-of-recognition-1cc1fa945ebd5f45016d72958808a753.png";